import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Cog"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-cog',
    templateUrl: './icon-cog.component.html',
    styleUrls: ['./icon-cog.component.scss'],
    standalone: false
})
export class IconCogComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
